<template>
  <div class="nursing-bill">
    <el-row>
      <el-form :inline="true" :model="queryForm" class="demo-form-inline toolbar" style="padding-bottom:0px"
        @submit.native.prevent>
        <el-form-item label="老人姓名">
          <el-input v-model.trim="queryForm.oldmanNameKeyword" placeholder="搜索老人姓名"
            style="width:130px" clearable></el-input>
        </el-form-item>
        <el-form-item label="护理项目">
          <el-input v-model.trim="queryForm.projectName" placeholder="输入项目名称"
            style="width:130px" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker v-model="queryForm.timevalue" unlink-panels type="daterange"
            start-placeholder="开始日期" end-placeholder="结束日期"
            style="width:220px" value-format="yyyy-MM-dd" clearable></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="queryTable">查询</el-button>
          <el-button icon="el-icon-refresh" plain @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-table
        :data="tableData"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        style="width:100%"
        v-loading="loading"
      >
        <el-table-column prop="oldmanName" label="老人姓名" align="center"></el-table-column>
        <el-table-column prop="bedNo" label="床位" align="center" width="100px"></el-table-column>
        <el-table-column prop="projectName" label="护理项目" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="计费金额（元）" align="center" width="140px">
          <template slot-scope="scope">
            <span style="color:#f53f3f;font-weight:600">
              {{ Number(scope.row.amount || 0).toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="计费时间" align="center" width="180px">
          <template slot-scope="scope">{{ formatDateTime(scope.row.billTime) }}</template>
        </el-table-column>
      </el-table>
    </el-row>

    <div style="text-align:right;padding:8px 16px;font-size:15px;font-weight:bold;background:#fff;">
      本页合计：{{ pageTotal }} 元
    </div>
    <el-pagination
      class="fenye"
      background
      layout="total, prev, pager, next"
      :total="total"
      :current-page.sync="pageNum"
      :page-size="pageSize"
      @current-change="changePage"
      align="center"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'NursingBillList',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      pageTotal: '0.00',
      queryForm: {
        oldmanNameKeyword: '',
        projectName: '',
        timevalue: null,
      },
    };
  },
  methods: {
    tableRowStyle({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'background-color:#ffffff' : 'background-color:#e4f5f8';
    },
    queryTable() {
      this.pageNum = 1;
      this.fetchList();
    },
    resetForm() {
      this.queryForm.oldmanNameKeyword = '';
      this.queryForm.projectName = '';
      this.queryForm.timevalue = null;
      this.pageNum = 1;
      this.fetchList();
    },
    changePage(val) {
      this.pageNum = val;
      this.fetchList();
    },
    formatDateTime(val) {
      if (!val) return '';
      const d = new Date(val);
      if (isNaN(d.getTime())) return val;
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    fetchList() {
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      if (this.queryForm.oldmanNameKeyword) param.oldmanNameKeyword = this.queryForm.oldmanNameKeyword;
      if (this.queryForm.projectName)       param.projectName       = this.queryForm.projectName;
      if (this.queryForm.timevalue && this.queryForm.timevalue.length === 2) {
        param.startTime = this.queryForm.timevalue[0];
        param.endTime   = this.queryForm.timevalue[1];
      }
      this.loading = true;
      this.$postJson('omc/nursingBill/queryListWithPage', param).then(res => {
        if (res.code === 200) {
          this.tableData = res.result.list  || [];
          this.total     = Number(res.result.total || 0);
          this.pageTotal = this.tableData
            .reduce((s, r) => s + Number(r.amount || 0), 0)
            .toFixed(2);
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.fetchList();
  },
};
</script>

<style lang="scss" scoped>
.nursing-bill {
  padding: 16px;
  background: #fff;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
</style>
